export const Role = {
    SuperAdmin: 'SuperAdmin',
    Admin: 'Admin',
    User: 'User',
    AuditAdmin: 'AuditAdmin',
    Auditor: 'Auditor',
}